import { PermissionScopeFormType } from 'components/permissions/UpdatePermissionScopeForm';

export const updatePermissionScopeInitialValues: Partial<PermissionScopeFormType> = {};
